import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Menu } from 'antd-mobile';
import DfMenu from '@/components/Menu';
import FilterBar from '@/components/FilterBar';
import { IMenuData, ActiveMenuType } from '@/interface/index';
import classnames from 'classnames';
import homeApi from '@/entity/module/home/homeAPi';
import styles from './index.less';
import './globalIndex.less';
import { TLang } from '@/utils/lang';

interface cb {
  type: ActiveMenuType;
  data: any;
}

interface IFilterMenuBar {
  data: any;
  active: ActiveMenuType; // 展示 左边、右边 Menu
  changeActive: (t: ActiveMenuType) => void;
  leftObj: IMenuData | undefined;
  rightObj: IMenuData | undefined;
  closeMenuBar: () => void;
  clickItem: ({ t: ActiveMenuType, a: IMenuData }) => void; // 点击 Item, 记得影藏active
  className?: any;
  maskHei?: string; //  修复mask bug
  children?: React.ReactNode;
  history?: any;
  dispatch?: any;
}
interface IMenu {
  origin: Array<IMenuData> | null;
  menu: Array<IMenuData> | null;
}
const sortArr = [
  {
    value: 1,
    label: TLang('综合排序', 'home', false, false, null)
  },
  {
    value: 2,
    label: TLang('离我最近', 'home', false, false, null)
  },
  {
    value: 3,
    label: TLang('价格最低', 'home', false, false, null)
  }
];

function getMenuValue(obj) {
  if (!obj) {
    return;
  }
  if (obj.districtId) {
    return [obj.districtId, obj.value];
  } else {
    return [obj.value];
  }
}
const MenuBar = function (props: IFilterMenuBar) {
  const maskRef: any = useRef();
  const antdMenuRef: any = useRef();
  const { leftObj, rightObj, active, data } = props;
  // console.log(leftObj,rightObj)
  // 区域、商圈 数据 Arr{元数据，菜单数据}

  // 排序菜单
  const [sortMenu] = useState<Array<IMenuData>>(sortArr);

  // 点击排序 Item
  const onSortChange = function (value) {
    console.log(value);

    const item = sortMenu.find((item) => item.value === value[0]);

    props.clickItem && props.clickItem({ type: ActiveMenuType.right, data: item || null });
  };

  // 点击 商圈Item
  const onDistrictChange = function (value: IMenuData) {
    let val = JSON.parse(JSON.stringify(value));
    if (val && val.value == 0 && val.districtId !== 0) {
      const dis = data.find((item) => item.value === val.districtId);
      val.label = dis.label;
    }
    props.clickItem && props.clickItem({ type: ActiveMenuType.left, data: val || null });
  };
  const dfMenuRef = useRef();
  // useEventListener('touchmove',(e)=>{
  //   console.log('0000',e);
  //   e.stopPropagation();
  //   e.preventDefault();
  // },maskRef.current)

  const closeMenu = () => {
    // console.log('sc click...');
    props && props.closeMenuBar();
  };
  const filterBarClick = (t: ActiveMenuType) => {
    if (t === ActiveMenuType.left) {
      props.changeActive(ActiveMenuType.left);
    } else if (t === ActiveMenuType.right) {
      props.changeActive(ActiveMenuType.right);
    } else {
      props.changeActive(ActiveMenuType.none);
    }
  };

  return (
    <>
      <div className={`${styles.navBar} ${props.className}`}>
        <FilterBar
          leftObj={leftObj}
          rightObj={rightObj}
          active={active}
          barClick={filterBarClick}
        />
        {active === ActiveMenuType.right ? (
          <Menu
            className="dlMenu singleMenu"
            data={sortMenu}
            value={[rightObj && rightObj.value]}
            level={0}
            onChange={onSortChange}

          // ref={antdMenuRef}
          // height={document.documentElement.clientHeight * 0.6}
          />
        ) : null}
        {active === ActiveMenuType.left && data ? (
          <div className={styles.dfMenuWrapper}>
            <DfMenu data={data} value={getMenuValue(leftObj)} onChange={onDistrictChange} />
          </div>
        ) : null}
      </div>
      {active !== ActiveMenuType.none ? (
        <div
          className="menu-mask"
          ref={maskRef}
          style={{ height: props.maskHei }}
          onClick={closeMenu}
        ></div>
      ) : null}
    </>
  );
};

export default MenuBar;
